import ENDPOINTS from "constants/api.constants"
import axios, { AxiosResponse } from "axios"
import getHeaders from "utils/GetHeaders"
import { ISearchApiFeatures } from "types/addListing.types"

export const getMapSearchResults = async (query: string): Promise<AxiosResponse<ISearchApiFeatures[]>> => {
  const headers = getHeaders(false)
  return await axios.get(`${ENDPOINTS.GET_MAP_SEARCH_RESULTS}?q=${query}/`, headers)
}
